// extracted by mini-css-extract-plugin
export default {"Loading-default":"theme-default_Loading-default__dZWgs","Circle-default":"theme-default_Circle-default__eH8w6","loading":"theme-default_loading__UjYj1"};